import script from "./ManagersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagersView.vue?vue&type=script&setup=true&lang=js"

import "./ManagersView.vue?vue&type=style&index=0&id=6e9d6092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9d6092"]])

export default __exports__